import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
function GrnPdfFooter() {
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <>
      {/* <Box mt={6} mb={6}>
        <Typography fontWeight="bold">RECEIVED CONDITION:</Typography>
      </Box> */}

      <Divider
        sx={{
          mt: 2,
          // color: "black",
          // borderColor: "black",
          borderBottom: "1px dashed black",
        }}
      />

      <Box sx={{ ...styles.box_center_align, color: "black" }}>
        <Typography variant="body_xxs">End Of Document</Typography>
      </Box>
    </>
  );
}

export default GrnPdfFooter;
